// Libraries.
import styled from 'styled-components';
import {
    spanishViridian25,
    spanishViridian500,
} from '@habitech/shared';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

export const List = styled.ul`
    display: flex;
    justify-content: center;
    margin: 40px 0 24px 0;
`;

export const ListItem = styled.li`
    width: 40px;
    height: 40px;
    color: ${({ theme }) => theme.color.dark};
    font-weight: 400;
    font-size: 14px;
    margin: 0 8px;
    list-style-type: none;
    &.separator {
        opacity: 0.25;
    }
    &.arrow {
        width: auto;
        border-radius: 0;
        height: 24px;
        margin: 8px 0;
        &.left {
            margin-left: 0;
            padding-right: 16px;
        }
        &.right {
            margin-right: 0;
            padding-left: 16px;
        }
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        &.arrow {
            margin: 8px 16px;
        }
    }
`;

export const Link = styled.div<{ href?: string }>`
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    color: inherit;
    svg path {
        fill: ${({ theme }) => theme.color.spanishViridian500};
        stroke-width: 30px;
        stroke: ${({ theme }) => theme.color.spanishViridian500};
    }
    &.arrow {
        width: 24px;
        height: 24px;
        align-self: center;
        margin: auto;
    }
    &.active {
        font-weight: 700;
        background: ${spanishViridian25};
        color: ${spanishViridian500};
        border: 1px solid ${spanishViridian500};
    }
`;

export const CounterWrapper = styled.div`
    color: ${({ theme }) => theme.color.scarpaGray600};
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    b {
        font-weight: 700;
    }
`;

export const ButtonArrow = styled.div`
    position: relative;
    border-radius: 4px;
    border: 1px solid #d3d3d4;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px;
    margin-top:-8px;
    color:${spanishViridian500} ;
`;